"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTabComponentByType = exports.getTabKeyByType = exports.getTabIconByType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const INFOBOX_TABS = {
    [bridge_schema_1.InfoBoxTabType.Description]: {
        icon: ui_1.Icons.Info,
        key: 'info',
        component: Promise.resolve().then(() => __importStar(require("../organisms/InfoTab"))).then(({ InfoTab }) => InfoTab),
    },
    [bridge_schema_1.InfoBoxTabType.Motion]: {
        icon: ui_1.Icons.Motion,
        key: 'motion',
        component: Promise.resolve().then(() => __importStar(require("../organisms/MotionsTab"))).then(({ default: MotionsTab }) => MotionsTab),
    },
    [bridge_schema_1.InfoBoxTabType.CrossSections]: {
        icon: ui_1.Icons.Cross_Sections,
        key: 'cross-sections',
        component: Promise.resolve().then(() => __importStar(require("../organisms/CrossSectionsTab"))).then(({ CrossSectionsTab }) => CrossSectionsTab),
    },
    [bridge_schema_1.InfoBoxTabType.BoneParts]: {
        icon: ui_1.Icons.Parts,
        key: 'parts',
        component: Promise.resolve().then(() => __importStar(require("../organisms/PartsTab"))).then(({ PartsTab }) => PartsTab),
    },
    [bridge_schema_1.InfoBoxTabType.BoneSurfaces]: {
        icon: ui_1.Icons.Surfaces,
        key: 'surfaces',
        component: Promise.resolve().then(() => __importStar(require("../organisms/SurfacesTab"))).then(({ SurfacesTab }) => SurfacesTab),
    },
    [bridge_schema_1.InfoBoxTabType.BoneLandmarks]: {
        icon: ui_1.Icons.Landmarks,
        key: 'landmarks',
        component: Promise.resolve().then(() => __importStar(require("../organisms/LandmarksTab"))).then(({ LandmarksTab }) => LandmarksTab),
    },
    [bridge_schema_1.InfoBoxTabType.MuscleOI]: {
        icon: ui_1.Icons.Oi,
        key: 'oi',
        component: Promise.resolve().then(() => __importStar(require("../organisms/MuscleOITab"))).then(({ MuscleOITab }) => MuscleOITab),
    },
    [bridge_schema_1.InfoBoxTabType.OriginTrace]: {
        icon: ui_1.Icons.Origin_Path,
        key: 'origin-path',
        component: Promise.resolve().then(() => __importStar(require("../organisms/OriginTab"))).then(({ OriginTab }) => OriginTab),
    },
    [bridge_schema_1.InfoBoxTabType.BranchesTrace]: {
        icon: ui_1.Icons.Branches,
        key: 'branches',
        component: Promise.resolve().then(() => __importStar(require("../organisms/BranchesTab"))).then(({ BranchesTab }) => BranchesTab),
    },
    [bridge_schema_1.InfoBoxTabType.Innervation]: {
        icon: ui_1.Icons.Innervation,
        key: 'nerves',
        component: Promise.resolve().then(() => __importStar(require("../organisms/NervesTab"))).then(({ NervesTab }) => NervesTab),
    },
    [bridge_schema_1.InfoBoxTabType.ArterialSupply]: {
        icon: ui_1.Icons.Arteries,
        key: 'arteries',
        component: Promise.resolve().then(() => __importStar(require("../organisms/ArteriesTab"))).then(({ ArteriesTab }) => ArteriesTab),
    },
    [bridge_schema_1.InfoBoxTabType.Models]: {
        icon: ui_1.Icons.Models,
        key: 'models',
        component: Promise.resolve().then(() => __importStar(require("../organisms/ModelsTab"))).then(({ default: ModelsTab }) => ModelsTab),
    },
    [bridge_schema_1.InfoBoxTabType.VideosTreatments]: {
        icon: ui_1.Icons.Infobox_Video_Treatments,
        key: 'treatments',
        component: Promise.resolve().then(() => __importStar(require("../organisms/TreatmentsTab"))).then(({ TreatmentsTab }) => TreatmentsTab),
    },
    [bridge_schema_1.InfoBoxTabType.VideosConditions]: {
        icon: ui_1.Icons.Infobox_Video_Conditions,
        key: 'conditions',
        component: Promise.resolve().then(() => __importStar(require("../organisms/ConditionsTab"))).then(({ ConditionsTab }) => ConditionsTab),
    },
    [bridge_schema_1.InfoBoxTabType.VideosExercises]: {
        icon: ui_1.Icons.Infobox_Video_Exercises,
        key: 'exercises',
        component: Promise.resolve().then(() => __importStar(require("../organisms/ExercisesTab"))).then(({ ExercisesTab }) => ExercisesTab),
    },
    [bridge_schema_1.InfoBoxTabType.VideosStretches]: {
        icon: ui_1.Icons.Infobox_Video_Stretches,
        key: 'stretches',
        component: Promise.resolve().then(() => __importStar(require("../organisms/StretchesTab"))).then(({ StretchesTab }) => StretchesTab),
    },
    [bridge_schema_1.InfoBoxTabType.Craniometrics]: {
        icon: ui_1.Icons.Craniometrics_Infobox,
        key: 'craniometrics',
        component: Promise.resolve().then(() => __importStar(require("../organisms/CraniometricsTab"))).then(({ CraniometricsTab }) => CraniometricsTab),
    },
    [bridge_schema_1.InfoBoxTabType.Sutures]: {
        icon: ui_1.Icons.Sutures_Infobox,
        key: 'sutures',
        component: Promise.resolve().then(() => __importStar(require("../organisms/SuturesTab"))).then(({ SuturesTab }) => SuturesTab),
    },
    [bridge_schema_1.InfoBoxTabType.DrainageTrace]: {
        icon: ui_1.Icons.Origin_Path,
        key: 'drainage-trace',
        component: Promise.resolve().then(() => __importStar(require("../organisms/DrainageTab"))).then(({ DrainageTab }) => DrainageTab),
    },
    [bridge_schema_1.InfoBoxTabType.TributariesTrace]: {
        icon: ui_1.Icons.Branches,
        key: 'tributaries-trace',
        component: Promise.resolve().then(() => __importStar(require("../organisms/TributariesTab"))).then(({ TributariesTab }) => TributariesTab),
    },
    [bridge_schema_1.InfoBoxTabType.Explode]: {
        icon: ui_1.Icons.Multi_Selection_Explode,
        key: 'explode',
    },
    [bridge_schema_1.InfoBoxTabType.Isolate]: {
        icon: ui_1.Icons.Isolate,
        key: 'isolate',
    },
};
function getTabIconByType(type) {
    return INFOBOX_TABS[type].icon;
}
exports.getTabIconByType = getTabIconByType;
function getTabKeyByType(type) {
    return INFOBOX_TABS[type].key;
}
exports.getTabKeyByType = getTabKeyByType;
function getTabComponentByType(type) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const Mock = ({ onResize: _onResize }) => ((0, jsx_runtime_1.jsx)("div", { "data-e2e": 'getTabComponentByType_div' }));
        const Component = (_a = (yield INFOBOX_TABS[type].component)) !== null && _a !== void 0 ? _a : Mock;
        return { default: Component };
    });
}
exports.getTabComponentByType = getTabComponentByType;
